var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRewardSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-reward-small_svg__a",
    x1: "77.158%",
    x2: "4.024%",
    y1: "-29.429%",
    y2: "178.738%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EAD3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B244D2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ic-reward-small_svg__c",
    width: "122.2%",
    height: "118.7%",
    x: "-11.1%",
    y: "-9.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0.721957237 0 0 0 0 0.404874034 0 0 0 0 0.814439838 0 0 0 0.550016984 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic-reward-small_svg__b",
    d: "M7.052.191l5.508 3.255c.248.146.4.412.4.7v6.542a.814.814 0 01-.4.7l-5.508 3.254a.812.812 0 01-.827 0L.717 11.388a.816.816 0 01-.4-.7V4.146c0-.288.153-.554.4-.7L6.225.19a.816.816 0 01.827 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1.5 .5)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#ic-reward-small_svg__a)",
    xlinkHref: "#ic-reward-small_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ic-reward-small_svg__c)",
    xlinkHref: "#ic-reward-small_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#3B385E",
    strokeWidth: 0.809,
    xlinkHref: "#ic-reward-small_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B385E",
    fillRule: "nonzero",
    d: "M8.638 6.261a.147.147 0 00-.105-.04h-.777a1.525 1.525 0 00-.29-.64h1.058a.143.143 0 00.105-.04.135.135 0 00.04-.102v-.453a.138.138 0 00-.04-.102.147.147 0 00-.105-.04h-3.78a.145.145 0 00-.104.04.133.133 0 00-.041.102v.591c0 .039.014.072.043.1a.142.142 0 00.102.042h.659c.639 0 1.045.167 1.217.502H4.744a.14.14 0 00-.104.04.133.133 0 00-.041.102v.453c0 .042.013.076.04.103a.15.15 0 00.105.04h1.94a.877.877 0 01-.466.555c-.244.127-.565.19-.965.19h-.509a.141.141 0 00-.102.043.133.133 0 00-.043.1v.564c0 .039.013.071.04.098.582.604 1.336 1.45 2.263 2.536a.134.134 0 00.114.054h.886c.063 0 .107-.027.131-.08.03-.054.025-.104-.018-.151-.884-1.06-1.58-1.854-2.085-2.381.515-.06.933-.222 1.254-.489.32-.266.516-.613.586-1.04h.763a.143.143 0 00.105-.04.135.135 0 00.04-.102v-.453a.138.138 0 00-.04-.102z"
  }))));
}
export default SvgIcRewardSmall;